import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import CaesImg from './../../../img/caes.png';
import CaesRecorridoImg from './../../../img/cae_recorrido.png';
import HoraInstalacionImg from './../../../img/horaInstalacion.png';
import CaeMesaImg from './../../../img/cae_mesaCasilla.png';
import SIJEMovilImg from './../../../img/sije_movil_incidente.png';
import CatalogoSIJEImg from './../../../img/catalogoSIJE.png';
import MovilCasillaImg from './../../../img/sije_movil_casilla.png';
import AccionesComunes from '../../AccionesComunes';

class JornadaElectoral extends Component {

    componentDidMount(){
        document.title = "Ayuda | Jornada Electoral"

        var activeMenu = document.getElementById("jornadaElec");
        activeMenu.classList.add("active");
    }

    componentWillUnmount(){
        document.getElementById("conoceSIJE").classList.remove("active");
        document.getElementById("FuncCasilla").classList.remove("active");
        document.getElementById("jornadaElec").classList.remove("active");
        document.getElementById("preguntasFrec").classList.remove("active");

        var colapsarMenu = document.getElementById("menuResponsivo");
        colapsarMenu.classList.replace("show", "not");
    }

    render () {
        return (
            <div className="container contenido">
                <AccionesComunes />
                <div className="migajas">
                    <small>
                        <Link to="./QueEsSIJE">Inicio</Link>
                        <span>Jornada Electoral</span>
                    </small>
                </div>
                <div className="col-md-12 text-center mb-5">
                    <h1 className="tituloPagina">Jornada Electoral</h1>
                </div>

                <div className="row bordes">
                    <div className="col-md-6 col-sm-12">
                    <div className="floatLF height100 numerales">
                            <p>1</p>
                        </div>
                        <p>                  
                            A partir de las 7:30 horas las y los CAE inician su recorrido por las casillas que les corresponden.
                        </p>
                    </div>
                    <div className="col-md-6 col-sm-12 centrar-vertical horizontal">
                        <img src={CaesImg} alt="CAES de casilla" />
                    </div>
                </div>

                <div className="row bordes">
                    <div className="col-md-6 col-sm-12 centrar-vertical horizontal">
                        <img src={CaesRecorridoImg} alt="Recorrido CAE" />
                    </div>
                    <div className="col-md-6 col-sm-12">
                    <div className="floatLF height100 numerales">
                            <p>2</p>
                        </div>
                        <p>                  
                        Las y los CAE realizan, al menos, dos visitas a sus casillas para recopilar la información requerida por el SIJE.
                        </p>
                    </div>
                </div>

                <div className="row bordes">
                    <div className="col-md-6 col-sm-12">
                    <div className="floatLF height100 numerales">
                            <p>3</p>
                        </div>
                        <p>                  
                        En su primera visita recopilan información sobre la instalación de las casillas. 
                        </p>
                        <p>                  
                        Conforme las casillas concluyen con su instalación, y se registra en el Acta de la Jornada Electoral la hora de instalación de casilla, la o el CAE recopila este dato. 
                        </p>
                    </div>
                    <div className="col-md-6 col-sm-12 centrar-vertical horizontal">
                        <img src={HoraInstalacionImg} alt="hora de instalación" />
                    </div>
                </div>

                <div className="row bordes">
                    <div className="col-md-6 col-sm-12 centrar-vertical horizontal">
                        <img src={CaeMesaImg} alt="Mesa Directiva de Casilla y CAE" />
                    </div>
                    <div className="col-md-6 col-sm-12">
                    <div className="floatLF height100 numerales">
                            <p>4</p>
                        </div>
                        <p>                  
                        Si la/el CAE reporta vía datos, transmite la hora de instalación y, posteriormente, recopilan y transmiten el resto de la información de su primera visita (número de funcionarios de casilla y representantes de partidos políticos y candidaturas independientes).
                        </p>
                        <p>                  
                        Si la/el CAE reporta vía voz, recopila toda la información correspondiente a su primera visita para transmitirla en el horario asignado.
                        </p>
                    </div>
                </div>

                <div className="row bordes">
                    <div className="col-md-6 col-sm-12">
                    <div className="floatLF height100 numerales">
                            <p>5</p>
                        </div>
                        <p>                  
                        En su segunda visita, recopilan y transmiten información sobre la hora de inicio de la votación y la presencia de observadores electorales, así como el detalle de la integración de las mesas directivas de casilla y la asistencia de representantes de partidos políticos y candidaturas independientes, según el tipo de nombramiento. 
                        </p>
                    </div>
                    <div className="col-md-6 col-sm-12 centrar-vertical horizontal">
                        <img src={MovilCasillaImg} alt="Casilla SIJE" />
                    </div>
                </div>

                {/*<div className="row bordes">
                    <div className="col-md-6 col-sm-12 centrar-vertical horizontal">
                        <img src={SIJEMovilImg} alt="Incidentes SIJE" />
                    </div>
                    <div className="col-md-6 col-sm-12">
                    <div className="floatLF height100 numerales">
                            <p>6</p>
                        </div>
                        <p>                  
                        Si durante sus recorridos, tienen conocimiento de algún incidente de los establecidos en el Catálogo de Incidentes del SIJE, debe reportarlo de manera inmediata, ya sea vía voz o datos. 
                        </p>
                    </div>
                </div>

                <div className="row bordes">
                    <div className="col-md-6 col-sm-12">
                    <div className="floatLF height100 numerales">
                            <p>7</p>
                        </div>
                        <p>                  
                        Existen 18 diferentes incidentes, según el “Catálogo de incidentes SIJE” aprobado para el Proceso Electoral 2021.
                        </p>
                        <p>                
                        Dichos incidentes se clasifican según el momento en el que se pueden presentar: 
                        </p>
                        <ul>
                            <li>
                                Durante la instalación de casillas.
                            </li>
                            <li>
                                Durante el desarrollo de la votación.
                            </li>
                            <li>
                                Durante el cierre de la votación.   
                            </li>
                            <li>
                                Durante el escrutinio y cómputo.
                            </li>
                            <li>
                                Durante el Covid-19.
                            </li>
                        </ul>
                    </div>
                    <div className="col-md-6 col-sm-12 centrar-vertical horizontal">
                        <img src={CatalogoSIJEImg} alt="Catalogo de Incidentes SIJE" />
                    </div>
                </div>

                {/* <div className="row bordes">
                    <div className="col-md-12 text-center">
                        <h2>Desarrollo de la votación</h2>
                    </div>
                    <div className="col-md-6 col-sm-12 centrar-vertical horizontal">
                        <img src={VotacionCasilla} alt="Funcionarios de casilla" />
                    </div>
                    <div className="col-md-6 col-sm-12">
                        <div className="floatLF height100 numerales">
                            <p>2</p>
                        </div>
                        <p>
                            A las 8:00am (hora local), las casillas abren para atender a los electores, y continúan abiertas hasta las 6:00pm (hora local).
                        </p>
                    </div>
                </div> */}

                {/* <div className="row bordes">
                    <div className="col-md-12 text-center">
                        <h2>Cierre de la votación</h2>
                    </div>
                    <div className="col-md-6 col-sm-12">
                        <div className="floatLF height100 numerales">
                            <p>3</p>
                        </div>
                        <p>
                            A las 6:00pm (hora local), se cierran las casillas; a menos que haya electores formados para votar. Los funcionarios de casilla llenan los apartados correspondientes en el Acta de la jornada electoral.
                        </p>
                    </div>
                    <div className="col-md-6 col-sm-12 centrar-vertical horizontal">
                        <img src={CasillaCerrada} alt="Funcionarios de casilla" />
                    </div>
                </div>
 */}
                {/* <div className="row bordes">
                    <div className="col-md-12 text-center">
                        <h2>Escrutinio y cómputo</h2>
                    </div>
                    <div className="col-md-6 col-sm-12 centrar-vertical horizontal">
                        <img src={PaqueteElectoral} alt="Funcionarios de casilla" />
                    </div>
                    <div className="col-md-6 col-sm-12">
                        <div className="floatLF height100 numerales">
                            <p>4</p>
                        </div>
                        <p>
                            Una vez cerrada la casilla, los funcionarios de casilla se encargan de realizar el conteo de votos e integrar el paquete electoral que será entregado al Consejo Distrital.
                        </p>
                    </div>
                </div> */}
            </div>
        )
    }
}

export default JornadaElectoral;